import React from "react";
import "./Header.css";

const Header = () => {
  return (
    <header>
      <h2>The Comic Readlist</h2>
      <p>Find Your Favourite Comic Book......</p>
      <p>Total Budget: $361462</p>
    </header>
  );
};

export default Header;
